




















import { Component, Vue } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
import ContentProduct from '@/app/shared/components/contents/product.vue';
@Component({ components: { ContentProduct } })
export default class PanelProductComponent extends Vue {
  private show = false;

  private get refs() {
    return refsService;
  }
}
